import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import { useTracker } from '../../../context/hooks';
import { RecommendationBaseView } from '../../sharedComponents/RecommendationBaseView';
import { SeoRecommendations } from '../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ContentAssistantKBLink = () => {
  const {
    track
  } = useTracker();
  const handleClickKBLink = event => {
    track('clickedLearnMoreLink', {
      recommendationType: SeoRecommendations.INCREASE_WORD_COUNT,
      linkAddress: event.currentTarget.href
    });
  };
  return /*#__PURE__*/_jsx(UILink, {
    href: "https://knowledge.hubspot.com/website-pages/generate-content-with-ai-assistants",
    external: true,
    onClick: handleClickKBLink,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.linkText.INCREASE_WORD_COUNT_WITH_CONTENT_ASSISTANT"
    })
  });
};
export const IncreaseWordCountView = ({
  auditResult
}) => {
  const {
    status,
    count
  } = auditResult;
  return /*#__PURE__*/_jsx(RecommendationBaseView, {
    testId: "increase-word-count-rec",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.title.INCREASE_WORD_COUNT"
    }),
    description: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "xray-recommendation-lib.seo.recommendations.description.INCREASE_WORD_COUNT",
        options: {
          count
        }
      }), /*#__PURE__*/_jsx("div", {
        className: "m-top-3",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "xray-recommendation-lib.seo.recommendations.description.INCREASE_WORD_COUNT_WITH_CONTENT_ASSISTANT"
        })
      })]
    }),
    status: status,
    children: /*#__PURE__*/_jsx("div", {
      className: "m-left-6",
      children: /*#__PURE__*/_jsx(ContentAssistantKBLink, {})
    })
  });
};